module.exports = __webpack_public_path__ + "assets/img/binding-1.0a553dd7.jpg";